import React, { useState } from 'react';
import { Content, TableContent, CreateContent, BoxLoader } from './styled';
import { Dialog, DialogContent, DialogTitle, TextField, Select, MenuItem } from '@material-ui/core';
import { AlunoSearchInput } from "../../../components/Admin/AlunoSearchInput";
import { Button } from '@material-ui/core';
import { producaov2 } from '../../../services/apis';
import DataTable from '../../../components/DataTable';
import { smallDateFormatWithTimeResetUTC } from '../../../utils/Utils';
import Loading from "../../../components/Loader";

const ModalEvent = ({ open: externalOpen, onClose: externalOnClose }) => {
  const [id, setId] = useState(null);
  const [internalOpen, setInternalOpen] = useState(false);
  const [contacts, setContacts] = useState([]);
  const [createContact, setCreateContact] = useState(false);
  const [dataRegistro, setDataRegistro] = useState(false);
  const [options, setOptions] = useState([]);
  const [courseOptions, setCourseOptions] = useState([]);
  const [selectOptionType, setSelectOptionType] = useState();
  const [selectOptionCourse, setSelectOptionCourse] = useState();
  const [loading, setLoading] = useState(false);

  const isOpen = externalOpen !== undefined ? externalOpen : internalOpen;
  const handleClose = externalOnClose || (() => setInternalOpen(false));

  const handleModalClose = () => {
    handleClose();
    setId(null);
    setContacts([]);
    setCreateContact(false);
  };

  async function searchContacts() {
    setLoading(true);
    setCreateContact(false);
    setSelectOptionType("");
    setSelectOptionCourse("");
    setOptions([]);
    setCourseOptions([]);

    if (!id) {
      swal("Atenção", "É necessário selecionar o aluno que se deseja visualizar as informações", "warning")
      setLoading(false);
      return;
    }

    const get_contacts = await producaov2.get(`admin/contato-evento/${id}`);

    if (get_contacts.data) {
      console.log("RETORNOU: ", get_contacts.data)
      setContacts(get_contacts.data);
      setLoading(false);
    }

    return;
  }

  async function searchTypes() {
    if (createContact) {
      setCreateContact(false);
      return;
    }

    if (!id) {
      swal("Selecione um aluno", "Antes de fazer um registro, busque pelo aluno", "warning");
      return;
    }

    const get_types = await producaov2.get(`admin/contato-evento/types?id_aluno=${id}`);

    if (get_types.data) {
      console.log("TYPES", get_types.data);
      const op = get_types.data.tipos.map(elem => {
        return {
          key: elem.id,
          name: elem.descricao
        }
      });
      const pd = [...new Map(get_types.data.pedidos.map(elem =>
        [elem.id, { key: elem.id, name: elem.curso, data_cadastro: elem.data_cadastro }]
      )).values()];

      if (!pd || pd.length <= 0) {
        swal("Aluno não pagante!", "Aluno não possui nenhum curso PAGO registrado em plataforma. Apenas registramos contato de alunos pagantes.", "warning")
        setCreateContact(false);
        return;
      }
      console.log("pd[0]", pd[0])
      console.log("op[0]", op[0])

      setCreateContact(prev => !prev);
      setOptions(op);
      setCourseOptions(pd);
      pd[0]?.key && setSelectOptionCourse(pd[0]?.key)
      op[0]?.key && setSelectOptionType(op[0]?.key)
    }
  }

  async function register() {
    const payload = {
      id_pessoa: id,
      id_curso: selectOptionCourse,
      tipo_evento: selectOptionType,
      data_contato: dataRegistro,
    };
    console.log("PAYLOAD:: ", payload);
    try {
      const rs = await producaov2.post("admin/contato-evento", payload);
      if (rs.status == 200) {
        swal("Registro Efetuado com sucesso", "", "success")
        setTimeout(() => searchContacts(), 1000);
        return;
      }
    } catch (error) {
      swal("Erro ao fazer o registro", "error", "error")
    }
  };

  return (
    <>
      <Dialog
        maxWidth="md"
        open={isOpen}
        onClose={handleModalClose}
      >
        <DialogTitle>Registrar Contato</DialogTitle>
        <DialogContent
          style={{
            minHeight: "200px",
            minWidth: "50vw"
          }}
        >
          <Content>
            <AlunoSearchInput
              hideLabel
              handleChange={({ id }) => setId(id)}
            />
            <Button variant="contained" color="primary" onClick={() => searchContacts()}>Consultar</Button>
            <Button variant="contained" onClick={() => searchTypes()}>{!createContact ? "Registrar contato" : "Recolher"}</Button>
          </Content>
          {
            createContact && courseOptions.length > 0 && (
              <CreateContent>
                <Select
                  label="Curso do Pedido"
                  options={courseOptions}
                  defaultValue={courseOptions[0]?.key}
                  onChange={e => setSelectOptionCourse(e.target.value)}
                >
                  {courseOptions.map(option => {
                    return (
                      <MenuItem key={option.key} value={option.key}>
                        {option.name} - {option.data_cadastro}
                      </MenuItem>
                    )
                  })}
                </Select>
                <Select
                  label="Motivo do Contato"
                  options={options}
                  defaultValue={options[0]?.key}
                  onChange={e => setSelectOptionType(e.target.value)}
                >
                  {options.map(option => {
                    return (
                      <MenuItem key={option.key} value={option.key}>
                        {option.name}
                      </MenuItem>
                    )
                  })}
                </Select>
                <TextField
                  label="Data de Contato"
                  type="datetime-local"
                  value={dataRegistro}
                  onChange={(e) => setDataRegistro(e.target.value)}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
                <Button variant="contained" color="primary" onClick={() => register()}>Registrar</Button>
              </CreateContent>
            )
          }
          <TableContent>
            {
              loading && id && (
                <BoxLoader>
                  <Loading div />
                </BoxLoader>
              )
            }
            {
              contacts && !loading && id && contacts?.contatosFeitos && contacts?.contatosFeitos?.length <= 0 && (
                <BoxLoader>
                  <p>Aluno não possui registro de contato.</p>
                </BoxLoader>
              )
            }
            {
              contacts && !loading && contacts?.contatosFeitos && contacts?.contatosFeitos.length > 0 && (
                <DataTable
                  showFilters={false}
                  showPagination={false}
                  hasStickHeader
                  maxHeight="400px"
                  columns={[
                    { key: 'curso', name: "Curso" },
                    { key: 'nome_responsavel', name: 'Responsável' },
                    { key: 'tipo', name: 'Tipo' },
                    { key: 'created_at', name: 'Registro' }
                  ]}
                  rows={
                    contacts?.contatosFeitos
                      .sort((a, b) => new Date(b.data_contato).getTime() - new Date(a.data_contato).getTime())
                      ?.map(data => ({
                        curso: data.curso,
                        nome_responsavel: data?.nome_responsavel,
                        tipo: data.tipo.descricao,
                        created_at: smallDateFormatWithTimeResetUTC(data.data_contato)
                      }))
                  }
                  rowsPerPage={5}
                />
              )
            }
          </TableContent>
        </DialogContent>
      </Dialog>
    </>
  );
}

export default ModalEvent;